import AppointmentFooter from './AppointmentFooter'

export default AppointmentFooter